import React from "react";
import { render, unmountComponentAtNode } from "react-dom";
import { Loader, Toast, Fallback, ErrorBoundary } from "@sicredi/react";

import "./global.scss";
import App from "#/App";
import { onResponse } from "#/utils/request";
import { OidcProvider, OidcSecure } from "@axa-fr/react-oidc";

import oidcConfig from "./oidcConfig";
import { startApiMockServer } from "./api/__mocks__";

const loadingComponent = () => <Loader show fullScreen />;

const ROOT = document.getElementById("root")!;

function unmountRender(element: React.ReactElement) {
  unmountComponentAtNode(ROOT);
  render(element, ROOT);
}

unmountRender(loadingComponent());

if (!!process.env.REACT_APP_MIRAGE && process.env.REACT_APP_MIRAGE === "true") {
  startApiMockServer({});
}

onResponse((response) => {
  function handleClose() {
    window.auth.actions.logout();
    window.location.reload();
  }

  if (response?.status === 401) {
    unmountRender(
      <Fallback title="Acesso negado" onClose={handleClose}>
        Você não possui autorização para acessar essa aplicação.
      </Fallback>
    );
  }
});

unmountRender(
  <ErrorBoundary
    onClose={() => {
      window.location.reload();
    }}
  >
    <OidcProvider
      configuration={oidcConfig}
      loadingComponent={loadingComponent}
      authenticatingComponent={loadingComponent}
      callbackSuccessComponent={loadingComponent}
      authenticatingErrorComponent={() => {
        React.useEffect(() => {
          window.location.href = "/";
        }, []);
        return <></>;
      }}
    >
      <OidcSecure>
        <Toast />
        <App />
      </OidcSecure>
    </OidcProvider>
  </ErrorBoundary>
);
